@let _keys = keys();

<div class="content">
	<p class="p1" [translate]="_keys.message" [translateParams]="_keys.values"></p>
	@if (!!_keys.details) {
		<p class="details" [translate]="_keys.details" [translateParams]="_keys.values"></p>
	}
</div>
<footer>
	<div class="buttons">
		@if (_keys.cancel) {
			<button
				class="sm cancel"
				(click)="cancel()"
				stagesAutofocus
				[translate]="_keys.cancel"
				(keydown.escape)="cancel()"
			></button>
		}
		@if (_keys.ok) {
			<button
				class="sm"
				[ngClass]="{ delete: _keys.isDeleteButton, save: !_keys.isDeleteButton }"
				(click)="ok()"
				[translate]="_keys.ok"
			></button>
		}
	</div>
</footer>

